import React from "react";
import { Button, message, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useGoodsModel } from "../materialModel";
import { DataTable } from "./DataTable";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig, messageConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import useGlobalModel from "@/model/globalModel";
import { IImportParams, materialService } from "../materialService";

export const DataBox = () => {
    const { selectedRowKeys, updateEditFormVal, dataSource, loadData, exportGoods, downloadTpl, priceDownloadTpl } = useGoodsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const { beShopDs, setLoadingInfo, shopAndOrg: { shopId, shopCode, shopName, shopType }, shopDs } = useGlobalModel();

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let goodsEditKey = "13-2-2";
        let isFindNav = findNav(goodsEditKey);
        if (!isFindNav) {
            addNav(goodsEditKey, { id: selectedRowKeys[0], mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "物料跳转详情",
                type: "warning",
                text: "您还有物料详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(goodsEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }
    const upLoadCallback = (retData: IImportParams[]) => {
        if (!retData) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
            return message.warning("数据异常，请尝试重新导入")
        }
        let str: string = "";
        let total: number = 0
        let num: number = 0
        retData.forEach(item => {
            total += 1
            if (item.msg !== '导入成功!') {
                num += 1
                str += item.msg
            }
        })
        messageConfig(str ? "共导入" + total + "条，" + num + "条未成功，以下配件导入异常：" + str : "共导入" + total + "条，" + num + "条未成功，导入成功", 20, "info");
        setLoadingInfo({ loadingVisible: false, txt: "" });
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "13-2-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRowKeys[0] as string, mode: "look", },
            true
        );
    }
    const endEnquiry = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        globalPrompt("modal", {
            title: "询价截止",
            type: "success",
            text: "",
            okText: "确定",
            onOk: () => {
                let value: any = dataSource.find((item: any) => item.id == selectedRowKeys[0])
                materialService.endEnquiry(value.code).then(res => {
                    globalPrompt("message", { text: `${res.retMsg}`, type: "info" });
                    loadData()
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })

    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.DATA_M_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { addNav("13-2-1", { id: "", mode: "add" }) }}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_M_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_M_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_M_IM}>
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/base/material/import`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "正在导入中" }), { shopId }, false)}>
                <Button className="mr-5" type="primary" shape="round">导入</Button>
            </Upload>
        </YhAuth>
        {/* <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/base/material/import/details/update/${shopId}`, loadData)}>
            <Button className="mr-5" type="primary" shape="round">更改单位</Button>
        </Upload> */}
        {/* <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/base/material/importPricePro`, loadData, () => { }, { shopId })}>
            <Button className="mr-5" type="primary" shape="round">批量更新</Button>
        </Upload> */}
        {/* <YhAuth resCode={ResourceAuthEnum.DATA_M_EX}> */}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => { exportGoods().then() }}
        >导出</Button>
        {/* </YhAuth> */}
        <YhAuth resCode={ResourceAuthEnum.DATA_M_DLOAD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { downloadTpl().then() }}
            >下载模板</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_M_ENQUIRYEND}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={endEnquiry}
            >询价截止</Button>
        </YhAuth>
        {/* <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/base/material/importPrice`, loadData, () => { }, { shopId })}>
            <Button className="mr-5" type="primary" shape="round">导入价格</Button>
        </Upload>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => { priceDownloadTpl().then() }}
        >下载导入价格模板</Button> */}
    </>;

    return (
        //配件档案
        <YhBox action={action} style={{ height: 'calc(100vh - 190px)' }}>
            <DataTable />
        </YhBox>
    )
}

